module.exports={
    btn:{
        tips_reelect_btn:"Nuova immagine",
        cancel_btn:"Annulla",
        tips_continue_dispose:"Immagini supportate di alto livello",
        tips_return:"Nuova immagine",
        tips_upgrade:"Aggiornamento",
        tips_yes:"OK",
        delete:"Eliminare",
        download:"Scaricamento",
        upload_image:"Carica immagine",
        new_image:"Nuova immagine",
        save_all:"Salva tutto",
        cancel:"Annullamento",
        save:"Salva",
        view_comparison:"Visualizza il confronto",
        hide_comparison:"Nascondi confronto",
        previous:"Precedente",
        next:"Prossimo",
        continue_download:"Salva immagini con filigrane",
        present:"Applica a questa immagine",
        all_wait:"Applica a immagini in attesa",
        all:"Applica a tutte le immagini",
        history:"Storia",
        login:"Login",
    },
    tips:{
        please_upgrade:"Il tuo piano attuale non supporta il caricamento o l'upscaling delle immagini in batch. Si prega di aggiornarlo per godere di ulteriori vantaggi.",
        errorlistinfo:"XXX immagini sono selezionate. Le immagini XXX sono supportate, ma le immagini XXX non sono supportate. Le seguenti sono immagini non supportate:",
        max:"Supera il limite massimo di dimensione dell'immagine di 10 MB!",
        max_size:"Supera il limite massimo di lunghezza laterale dell'immagine di 4096px!",
        continue_dispose:"Immagini supportate di alto livello",
        please_multiple:"Si prega di selezionare l'ingrandimento.",
        max_multiple:"* La tua immagine verrà ingrandita al massimo a 4K (il lato più lungo non supererà i 4096px).",
        title:"Nome",
        reasons:"Motivi",
        upload_type:"Non supportato",
        used_up:"Il numero di immagini HD salvate senza filigrane è stato esaurito. Aggiorna il tuo account. Oppure puoi salvare immagini HD con filigrane.",
        edit_multiple:"Ci sono più immagini caricate. Seleziona le immagini di cui desideri modificare l'ingrandimento. Dopo la selezione, queste immagini verranno nuovamente ingrandite al nuovo ingrandimento.",
        download_confirm:"Alcune immagini sono ancora in fase di elaborazione. Sei sicuro di salvare tutte le immagini ingrandite? Quando salvi ripetutamente la stessa immagine, il numero di immagini salvate non verrà detratto nuovamente.",
        waiting_save:"Alcune immagini sono ancora in fase di elaborazione. Si prega di salvare più tardi.",
        
    },
    header:{
        title:"Upscaler di immagini AnyMP4 online",
        hd:" Immagini HD",
        watermarks:"senza filigrane può essere scaricato al momento.",
        view_details:"Visualizza dettagli",
        loading:"Caricamento…",
    },
    content:{
        failed:"Fallito",
        completed:"Completato",
        processing:"in lavorazione",
        img_processing:"In lavorazione…",
        img_failed:"Impossibile elaborare",
        uploading:"Caricamento in corso",
        img_uploading:"Caricamento...",
        wait_upoading:"In attesa di caricare...",
        waiting:"In attesa",
        img_waiting:"In attesa…",
        empty:"Vuoto",
        magnification:"Ingrandimento:",
        drop:"Oppure rilascia qui il tuo file immagine per migliorare e migliorare!",
        original:"Originale:",
        output:"Produzione:",
    },
    banner_msg:"Scegli un piano per Image Upscaler",
    monthly:"MENSILE",
    lifetime:"TUTTA LA VITA",
    choose_plan:"Scegli il tuo piano in base al numero di immagini",
    return_home:"Congratulazioni! Hai eseguito l'upgrade con successo. Si prega di tornare alla home page e utilizzare questo prodotto.",
    congratulations:"Congratulazioni! Hai eseguito l'upgrade con successo. I vantaggi sono stati vincolati all'indirizzo e-mail che hai lasciato durante l'aggiornamento. Si prega di utilizzare l'account registrato o collegato all'indirizzo e-mail a",
    login_benefits:"accedi per utilizzare i vantaggi",
    no_registered:". Se non hai registrato o collegato un account con l'indirizzo e-mail, per favore",
    register_account:"utilizzare l'indirizzo e-mail per registrare un account",
    other_accounts:" o collegare altri account a questo indirizzo e-mail per usufruire dei vantaggi.",
    btn_close:"Vicino",
    free:"Gratuito",
    btn_get_started:"Iniziare",
    // access_to:"Accesso a",
    upscale_images:"Immagini di alto livello",
    up_to:"Fino a",
    per_image:" per immagine",
    resolution_of:"Fino alla risoluzione di",
    default_level:"Immagini di alto livello nel livello predefinito",
    image_downloads:"2 download di immagini HD senza filigrana",
    unlimited_image:"Download di immagini illimitati con filigrana",
    SHA256_encryption:"Tecnica di crittografia SHA256",
    mon:"Mensile",
    images:"immagini",
    high_resolution:" con qualità ad alta risoluzione",
    tax_incl:"Tasse incluse.",
    image:"Immagine",
    secure_checkout:"Pagamento sicuro",
    everything:"Tutto in Free, e",
    upscaling_levels:"È possibile selezionare tutti i livelli di upscaling",
    unlimited_image_without:"Download di immagini illimitati senza filigrana",
    viewable_editing:"La cronologia di modifica visualizzabile è valida per",
    days:" giorni",
    high_level:"Alto livello",
    priority_processing:" trattamento prioritario",
    left:"Tutta la vita",
    resolution:" risoluzione",


    "history_will":"Scadrà dopo",
    "history.days":"Giorno/i",
    "history.hours":"ore",
    "expired":"Scaduto",
    "access_to":"Con la prova gratuita puoi solo",
    "pricing.upload_images":"Carica immagini",
    "pricing.under":"Sotto",
    "pricing.images":"immagini",
    "pricing.without_watermark":"senza filigrana",
    "pricing.process_images":"Elabora immagini fino a",
    "pricing.pixels":"pixel",
    "pricing.enjoy_limited":"Goditi voti esclusivi limitati",
    "pricing.download":"Scaricamento",
    "pricing.HD_images":"Immagini HD senza filigrana",
    "pricing.and_you":"E potresti soffrirne",
    "pricing.slow_upscaling":"aumento lento",
    "pricing.lower_priority":"priorità inferiore",
    "pricing.without":"senza filigrana",
    "pricing.tax":"L'imposta è inclusa nel prezzo di vendita e verrà calcolata automaticamente in base al tuo paese e alla tua regione. Nel carrello è possibile visualizzare l'importo fiscale dettagliato. L'importo del pagamento finale sarà uguale al prezzo visualizzato.",
    "pricing.you_can":"Con l'abbonamento puoi",
    "pricing.up_to":"Carica immagini fino a",
    "pricing.upscale_images":"Immagini di alto livello con",
    "pricing.no_watermark":"nessuna filigrana",
    "pricing.enhance":"Migliorare",
    "pricing.or_more":"immagini o altro",
    "pricing.in_batch":"in lotto",
    "pricing.enlarge_images":"Ingrandisci le immagini in",
    "pricing.and":"E",
    "pricing.times_with":"volte senza limiti",
    "pricing.enjoy":"Godere",
    "pricing.of_history":"del tempo di archiviazione della storia",
    "pricing.experience":"Esperienza",
    "pricing.fast_upscaling":"upscaling veloce",
    "pricing.higher_priority":"priorità più alta",
    "pricing.early_access":"Accesso anticipato alle nuove funzionalità",
    "pricing.cancel_anytime":"Annulla in qualsiasi momento",
    "pricing.lifetime_license":"Con la licenza a vita puoi",
    "pricing.and_there":"E ci sarà",
    "pricing.no_expiration":"nessuna data di scadenza",
    "pricing.unless":"a meno che tu non esaurisca tutti i livelli superiori",
}